<template>
  <footer class="eduvibe-footer-one edu-footer footer-style-default" style="background-color: #2e7245;">
    <div class="footer-top">
      <div class="container eduvibe-animated-shape">
        <div class="row g-5">
          <div class="col-lg-4 col-md-6 col-sm-12 col-12">
            <div class="edu-footer-widget">
              <div class="d-flex logo justify-content-center">
                <router-link to="/" @click="click_m()">
                  <img :src="url_api +
                    '/InstitucionUpea/' +
                    Institucion.institucion_logo
                    " alt="img" width="125" />
                </router-link>
              </div>
              <h4 class="widget-title text-center">{{ Institucion.institucion_nombre }}</h4>
              <p class="description">Formando profesionales de calidad, inculcando valores y ética al servicion de nuestra
                sociedad.</p>
              <ul class="social-share justify-content-center">
                <li><a :href="Institucion.institucion_facebook" target="_blank"><i class="icon-Fb"></i></a></li>
                <li><a :href="Institucion.institucion_facebook" target="_blank"><i class="icon-Twitter"></i></a></li>
                <li><a :href="Institucion.institucion_facebook" target="_blank"><i class="icon-youtube"></i></a></li>
              </ul>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="edu-footer-widget explore-widget">
              <h5 class="widget-title">Institución</h5>
              <div class="inner">
                <ul class="footer-link link-hover">
                  <li>
                    <router-link to="/servicios" @click="$store.commit('clickLink')">
                      <i class="icon-Double-arrow"></i> Servicios
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/ofertas" @click="$store.commit('clickLink')">
                      <i class="icon-Double-arrow"></i> Ofertas académicas
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/publicaciones" @click="$store.commit('clickLink')">
                      <i class="icon-Double-arrow"></i> Publicaciones
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/gaceta" @click="$store.commit('clickLink')">
                      <i class="icon-Double-arrow"></i> Gaceta
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/eventos" @click="$store.commit('clickLink')">
                      <i class="icon-Double-arrow"></i> Eventos
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/videos" @click="$store.commit('clickLink')">
                      <i class="icon-Double-arrow"></i> Videos
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- <div class="col-lg-3 col-md-6 col-sm-6 col-12">
            <div class="edu-footer-widget quick-link-widget">
              <h5 class="widget-title">Useful Links</h5>
              <div class="inner">
                <ul class="footer-link link-hover">
                  <li><a href="contact-us.html"><i class="icon-Double-arrow"></i>Contact Us</a></li>
                  <li><a href="pricing.html"><i class="icon-Double-arrow"></i>Pricing Plan</a></li>
                  <li><a href="instructor-profile.html"><i class="icon-Double-arrow"></i>Instructor Profile</a></li>
                  <li><a href="faq.html"><i class="icon-Double-arrow"></i>FAQ</a></li>
                  <li><a href="course-style-3.html"><i class="icon-Double-arrow"></i>Popular Courses</a></li>
                  <li><a href="purchase-guide.html"><i class="icon-Double-arrow"></i>Terms & Conditions</a></li>
                </ul>
              </div>
            </div>
          </div> -->

          <div class="col-lg-4 col-md-6 col-sm-6 col-12">
            <div class="edu-footer-widget">
              <h5 class="widget-title">Contact Info</h5>
              <div class="inner">
                <div class="widget-information">
                  <ul class="information-list">
                    <li><i class="icon-map-pin-line"></i>{{ Institucion.institucion_direccion }}
                    </li>
                    <li><i class="icon-phone-fill"></i><a href="#">+ 591 {{
                      Institucion.institucion_celular1
                    }}</a></li>
                    <li><i class="icon-phone-fill"></i><a href="#">+ 591 {{
                      Institucion.institucion_celular2
                    }}</a></li>
                    <li><i class="icon-mail-line-2"></i><a target="_blank" href="mailto:yourmailaddress@example.com">{{
                      Institucion.institucion_correo1 }}</a></li>
                    <li><i class="icon-mail-line-2"></i><a target="_blank" href="mailto:yourmailaddress@example.com">{{
                      Institucion.institucion_correo2 }}</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="shape-dot-wrapper shape-wrapper d-md-block d-none">
          <div class="shape-image shape-image-1">
            <img src="@/assets/images/shapes/shape-21-01.png" alt="Shape Thumb" />
          </div>
          <div class="shape-image shape-image-2">
            <img src="@/assets/images/shapes/shape-35.png" alt="Shape Thumb" />
          </div>
        </div>
      </div>
    </div>
    <div class="copyright-area copyright-default">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="inner text-center">
              <!-- <p>Copyright 2023 <a href="#">EduVibe</a> Designed By <a
                  href="https://themeforest.net/user/devsvibe">DevsVibe</a>. All Rights Reserved</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "footerView",
  computed: {
    ...mapState(["Institucion", "MenuConv", "MenuCur", "url_api"]),
  },
  methods: {
    click_m() {
      this.$store.commit("clickLink");
      // this.$store.commit("idEncrypt")
    },
    atras() {
      this.$router.go(-1)
    },
    adelante() {
      this.$router.go(1)
    }
  }
}

</script>
